import { cn } from "@/lib/utils"

type CourseSectionProps = React.HTMLAttributes<HTMLDivElement>

export function CourseSection({ children, className, ...props }: CourseSectionProps) {
  return (
    <section className={cn("flex flex-col gap-3", className)} {...props}>
      {children}
    </section>
  )
}
